import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import uuid from 'uuid/v4';
import { SearchDialogAnalyticsContext } from '../analytics';
const SearchSessionContext = /*#__PURE__*/React.createContext({
  searchSessionId: undefined
});
class SearchSessionProviderError extends Error {
  constructor() {
    super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
  }
}

/**
 * Wraps a component and provides the component with a searchSessionId.
 * The searchSessionId will either be retrieved from the closest SearchSessionProvider or a new one
 * will be generated with the wrapped component is mounted.
 */
export function injectSearchSession(Component) {
  const WrapperComponent = props => {
    return /*#__PURE__*/React.createElement(SearchSessionContext.Consumer, null, ({
      searchSessionId
    }) => {
      if (!searchSessionId) {
        throw new SearchSessionProviderError();
      }
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        searchSessionId: searchSessionId
      }));
    });
  };
  return WrapperComponent;
}
/**
 * A search session context provider.
 * This provides all children wrapped with injectSearchSession with the same search session id.
 * Noted a new search session id is generated if and only if this component is mounted.
 */
export class SearchSessionProvider extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      sessionKey: this.props.sessionKey,
      searchSessionId: uuid()
    });
  }
  static getDerivedStateFromProps(props, state) {
    return {
      sessionKey: props.sessionKey,
      searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_true' ? uuid() : state.searchSessionId
    };
  }
  render() {
    const {
      children
    } = this.props;
    const {
      searchSessionId
    } = this.state;
    return /*#__PURE__*/React.createElement(SearchSessionContext.Provider, {
      value: {
        searchSessionId
      }
    }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
      analyticContext: {
        searchSessionId
      },
      nonPrivacySafeAnalyticContext: {}
    }, children));
  }
}
export function useSearchSessionId() {
  const {
    searchSessionId
  } = useContext(SearchSessionContext);
  if (searchSessionId) {
    return searchSessionId;
  }
  throw new SearchSessionProviderError();
}